<template>
  <div>
  </div>
</template>
<script>
export default {
  props: {
    idx: {
      required: true,
    },
    name: {
      required: true,
    },
    items: {
      default: [],
    },
    show_level: {
      default: 0,  // 0: none, 1: less, 2: all
    },
    show_levels: {
      default: {2:1, 1:0, 0:2},
    },
    sort_descending: {
      default: true,
    },
    ellipsis_items: {
      default: items=>items.filter(i=>Boolean(i.doc_count > 1))
    },
  },
  data() {
    return {}
  }
}
</script>
